var exports = {
  "VH": "ForwardMessagePreview.module__preview___YzNVc0",
  "Qs": "ForwardMessagePreview.module__content___YzNVc0",
  "iU": "ForwardMessagePreview.module__message___YzNVc0",
  "Mg": "ForwardMessagePreview.module__messageWithAttachments___YzNVc0",
  "oh": "ForwardMessagePreview.module__edited___YzNVc0",
  "kp": "ForwardMessagePreview.module__attachmentRow___YzNVc0",
  "$r": "ForwardMessagePreview.module__attachmentIcon___YzNVc0",
  "eI": "ForwardMessagePreview.module__attachmentSummary___YzNVc0",
  "rs": "ForwardMessagePreview.module__attachmentSummaryWithText___YzNVc0",
  "vH": "ForwardMessagePreview.module__thumbnailStack___YzNVc0",
  "xn": "ForwardMessagePreview.module__thumbnail___YzNVc0",
  "q_": "ForwardMessagePreview.module__thumbnailImage___YzNVc0",
  "SK": "ForwardMessagePreview.module__thumbnailPlaceholder___YzNVc0",
  "XX": "ForwardMessagePreview.module__thumbnailPlaceholderIcon___YzNVc0",
  "Uy": "ForwardMessagePreview.module__thumbnailVideo___YzNVc0",
  "tk": "ForwardMessagePreview.module__thumbnailSensitive___YzNVc0",
  "$3": "ForwardMessagePreview.module__thumbnailWithOverflow___YzNVc0",
  "uZ": "ForwardMessagePreview.module__playIcon___YzNVc0",
  "mB": "ForwardMessagePreview.module__overflowCount___YzNVc0",
};

module.exports = exports;
